module.exports = __webpack_public_path__ + "assets/icons/truck.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/emojies/truck.png
// module id = ./src/styles/icons/emojies/truck.png
// module chunks = 0